import { render } from "./index.vue?vue&type=template&id=6fe0f63c&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Tournaments/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fe0f63c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fe0f63c', __exports__)) {
    api.reload('6fe0f63c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=6fe0f63c&ts=true", () => {
    api.rerender('6fe0f63c', render)
  })

}


export default __exports__